/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Raffle_Draw_ManyInputs */



/**
* | output |
* | --- |
* | "Draw {count} winners" |
*
* @param {Raffle_Draw_ManyInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const raffle_draw_many = /** @type {((inputs: Raffle_Draw_ManyInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Raffle_Draw_ManyInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Tirer ${i?.count} gagnants`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Sortear ${i?.count} ganadores`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Sortear ${i?.count} vencedores`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Estrai ${i?.count} vincitori`)
	return /** @type {LocalizedString} */ (`Draw ${i?.count} winners`)
});